<template>
  <div class="grid grid-cols-2 gap-3 w-full">
    <div v-for="option in options" :key="option.id" class="w-full">
      <input
        class="hidden"
        type="radio"
        :id="option.id"
        :value="option.id"
        :checked="tipoBusqueda === option.id"
        @click="setTipoBusqueda(option.id)"
      />

      <label
        :for="option.id"
        :class="[
          'w-full h-[48px] rounded-[10px] cursor-pointer transition flex items-center justify-center gap-2',
          tipoBusqueda === option.id
            ? 'bg-VERDE_TOP_CALIDAD text-white'
            : 'bg-[#E6E6E6] text-black'
        ]"
      >
        <img
          class="h-4 w-4"
          :src="option.icon"
          alt=""
          :class="[tipoBusqueda === option.id ? 'filter-selected' : 'filter-default']"
        />
        <span class="text-sm font-semibold leading-none">
          {{ option.label }}
        </span>
      </label>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue"

const props = defineProps({
  initialValue: { type: String, default: "por_auto" },
})

const emit = defineEmits(["selectedOption"])

// Orden exacto mockup
const options = ref([
  { id: "por_patente", label: "Por patente", icon: "/img/SVG/iconos_formularios/Patente-pos.svg" },
  { id: "por_auto", label: "Por Auto", icon: "/img/SVG/iconos_formularios/Autov2.svg" },
])

const tipoBusqueda = computed(() => props.initialValue)

const setTipoBusqueda = (value) => {
  emit("selectedOption", value)
}
</script>

<style scoped>
.filter-default {
  filter: grayscale(100%) brightness(0);
}

.filter-selected {
  filter: grayscale(100%) brightness(0) invert(100%);
}
</style>
